// imports
import { cartaoContinenteErrorHTML } from "./couponsComponents";
import { renderCarouselTemplate } from "./CouponsCarouselComponentJQuery";
import { getSVGIcon } from "../../utilities/globalUtilities";

/**
 * @function
 * @description - Initialize the cart coupons carousel Vue component
 * @param {String} el - Coupons carousel element selector
 * @param {Object} couponsData - Coupons carousel data
 */
const initJQueryCoupons = (el, couponsData) => {
    const hasNoCouponData = () => {
        return !couponsData || !couponsData.data || (!couponsData.data.gifts && !Object.keys(couponsData.data.gifts).length) || (!couponsData.data.vouchers && !Object.keys(couponsData.data.vouchers).length);
    };

    if (hasNoCouponData()) {
        const $couponsCarouselContainer = $(".js-cart-coupons-carousel-ref");
        const $couponsErrorMessage = $(".js-get-benefits-service-error");
        $couponsErrorMessage.append(cartaoContinenteErrorHTML(couponsData)).removeClass("d-none");
        $couponsCarouselContainer.addClass("d-none");

        return;
    }

    $(".coupons-grid-wrapper").parent().addClass("has-coupons-carousel");

    let {gifts, vouchers} = couponsData.data;
    let items = gifts.concat(vouchers);

    let couponsDataObj = {
        resources: couponsData.resources,
        brandList: couponsData.brandList,
        gifts: couponsData.data.gifts,
        items: items,
        itemsNumber: items.length,
        iconContinenteEntregaZero: getSVGIcon("icon-col-entregazero"),
        iconContinente: getSVGIcon("icon-logo-col"),
        iconZu: getSVGIcon("icon-logo-zu")
    };

    return renderCarouselTemplate($(el), couponsDataObj);
};

export { initJQueryCoupons };
